import { TextField } from '@material-ui/core'
import {
  StyledModalBoxSection,
  StyledModalBackButton,
  StyledModalTitle,
  StyledSubModal,
  StyledSitesSearchField,
  StyledSiteTitle,
  StyledTasksAssignmentHolder,
} from 'components/common/Modals/styles'
import { Flex } from 'components/common/styles'
import React, { useState, useEffect } from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { ReactComponent as ArrowRight } from 'assets/img/arrow-right.svg'
import TaskAssignmentSection from 'components/common/TaskAssignmentSection'
import { connect } from 'react-redux'
import { Site } from 'types/common'
import { fetchAssignData } from 'reducers/myJobs/reducer'
import { TRIGGER_ASSIGNMENTS } from 'constants/jobsTriggers'
import {
  AssignmentSubMenuProps,
  AssignmentTask,
} from './AssignmentSubMenu.types'
import messages from '../translate'

export const AssignmentSubMenu = ({
  intl: { formatMessage },
  isAssignmentSubModalOpened,
  setIsAssignmentSubModalOpened,
  fetchAssignData,
  triggerAssignmentData,
  formData,
  setFormData,
}: AssignmentSubMenuProps & WrappedComponentProps) => {
  const [sitesSearchFieldValue, setSitesSearchFieldValue] = useState('')
  const [filteredAssignmentData, setFilteredAssignmentData] = useState(
    triggerAssignmentData,
  )

  useEffect(() => {
    fetchAssignData({
      extraFields: ['avatar'],
    })
  }, [])

  useEffect(() => {
    const newAssignmentData = triggerAssignmentData.filter(
      ({ site: { name } }) =>
        name.toLowerCase().includes(sitesSearchFieldValue.toLowerCase()),
    )

    setFilteredAssignmentData(newAssignmentData)
  }, [sitesSearchFieldValue, JSON.stringify(triggerAssignmentData)])

  useEffect(() => {
    if (!isAssignmentSubModalOpened) {
      setSitesSearchFieldValue('')
    }
  }, [isAssignmentSubModalOpened])

  const renderSingleSite = (
    { id: siteId, name: siteName }: Site,
    tasks: AssignmentTask[],
  ) => (
    <div key={siteId}>
      <StyledSiteTitle>{siteName}</StyledSiteTitle>
      <StyledTasksAssignmentHolder>
        {tasks.map(task => (
          <TaskAssignmentSection
            {...task}
            key={task.id}
            siteId={siteId}
            formData={formData}
            setFormData={setFormData}
            fieldName={TRIGGER_ASSIGNMENTS}
          />
        ))}
      </StyledTasksAssignmentHolder>
    </div>
  )

  return (
    <StyledSubModal opened={isAssignmentSubModalOpened} direction="column">
      <StyledModalBoxSection>
        <Flex align="center">
          <StyledModalBackButton
            onClick={() => setIsAssignmentSubModalOpened(false)}>
            <ArrowRight />
          </StyledModalBackButton>
          <StyledModalTitle>
            {formatMessage(messages.editAssignees)}
          </StyledModalTitle>
        </Flex>
      </StyledModalBoxSection>
      <StyledModalBoxSection noBorder>
        <StyledSitesSearchField>
          <TextField
            placeholder={formatMessage(messages.searchBySite)}
            value={sitesSearchFieldValue}
            onChange={({ target: { value } }) =>
              setSitesSearchFieldValue(value)
            }
          />
        </StyledSitesSearchField>
        {filteredAssignmentData.map(
          ({ site, tasks }: { site: Site; tasks: AssignmentTask[] }) =>
            renderSingleSite(site, tasks),
        )}
      </StyledModalBoxSection>
    </StyledSubModal>
  )
}

export default connect(null, {
  fetchAssignData,
})(injectIntl(AssignmentSubMenu))
